import { SET_REGENERATING_DOWNLOADS } from './types';

export const setRegeneratingDownloads = (
  regeneratingDownloads: boolean
): {
  type: string;
  regeneratingDownloads: boolean;
} => ({
  type: SET_REGENERATING_DOWNLOADS,
  regeneratingDownloads,
});
